export default __webpack_public_path__ + "static/media/STARDUST_AWARENESS_MASTER_BLACK_250622-2.00f7ff3b.mp4";